import React from 'react';

import Profile from "../components/Profile";




const UserProfilePage = () => {


    return (
        <React.Fragment >
            <Profile />
        </React.Fragment>
    );
};

export default UserProfilePage;